import {Box, Divider, Typography} from "@mui/material";
import React, {useEffect} from "react";
import {useNavbar} from "../states/common/client";

export interface SimpleDocumentPageSpec {
    title: string,
    body: string,
}

export const SimpleDocumentPage: React.FC<SimpleDocumentPageSpec> = ({ title, body }) => {
    const { reset, setNavbarBackButton, setNavbarTitle } = useNavbar()

    useEffect(() => {
        reset()
        setNavbarBackButton(true)
        setNavbarTitle(title)
    }, []);

    return (
        <Box className={'fullscreen'} sx={{ padding: 2, maxWidth: 800, margin: "0 auto" }}>
            <Typography variant="h5" component="h1" gutterBottom>
                {title}
            </Typography>
            <Divider sx={{ marginY: 2 }} />
            <Typography variant="body1" component="p">
                {body.split("\n").map((line, index) => (
                    <React.Fragment key={index}>
                        {line}
                        <br />
                    </React.Fragment>
                ))}
            </Typography>
        </Box>
    )
}